import React from 'react';
import { useSelector } from 'react-redux';
import { State } from 'store/onboarding';
import useTask from 'components/onboarding/useTask';

import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import { LIST_SLIDE_KEY } from 'components/onboarding/constants';
import * as Types from 'components/onboarding/typings';

interface Props {
  task: Types.Task;
  isOnHomePage?: boolean;
}

function TaskTitle({ task: _task, isOnHomePage }: Props) {
  const classes = useStyles();
  const task = _task || useTask();
  const onboardingState: State = useSelector((state: any) => state.onboarding);
  const { slideKey } = onboardingState;

  if (!task) {
    return null;
  }

  const { isComplete, title, isPro } = task;

  return (
    <div className={classes.root}>
      {isComplete ? (
        <CheckCircleIcon
          fontSize={isOnHomePage ? 'small' : 'inherit'}
          className={classNames({ [classes.checkIcon]: !isOnHomePage }, classes.checked)}
          data-testid="checked-icon"
        />
      ) : (
        <CheckCircleIcon
          color="disabled"
          fontSize={isOnHomePage ? 'small' : 'inherit'}
          className={classNames({ [classes.checkIcon]: !isOnHomePage })}
          data-testid="unchecked-icon"
        />
      )}
      <Typography
        className={classNames(
          { [classes.completed]: isComplete && slideKey !== LIST_SLIDE_KEY },
          classes.title,
        )}
        variant="body2"
      >
        {title}
        {!task.required && ' (Optional)'}
      </Typography>
      {isPro && (
        <Typography variant="caption" color="primary" className={classes.tag}>
          PRO
        </Typography>
      )}
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  checkIcon: {
    fontSize: 14,
  },
  checked: {
    color: theme.palette.success.main,
  },
  completed: {
    color: theme.palette.success.main,
  },
  title: {
    marginLeft: theme.spacing(3),
  },
  tag: {
    marginLeft: theme.spacing(0.5),
    marginTop: -theme.spacing(),
  },
}));

export default TaskTitle;
